import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectOpportunity } from '../../../store/opportunity/opportunitySlice';
import { columnsPositions } from '../../helpers/columnsOpportunity';
import { deleteOpportunity } from '../../helpers/opportunity';
import { TableLayout } from '../../layout/TableLayout';
import { EditOportunity } from '../opportunities/EditOportunity';
import { DivestAll } from './DivestAll';


export const AdminPositionsTable = ({ rows, setReloadData, vehicles }) => {

    const { t } = useTranslation('global');
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [openEdit, setOpenEdit] = useState(false);
    const [openDivest, setOpenDivest] = useState(false);
    const { userToAction } = useSelector(state => state.partner)

    const onEditClick = (e) => {
        dispatch(selectOpportunity(e.row))
        setOpenEdit(true)
    }
    
    const onDeleteClick = async (e) => {
        await deleteOpportunity(e, t('delete.successMsg'), t('delete.errorMsg'), t('delete.cancelButton'), t('delete.confirmButton'), t('delete.deleteConfirm'))
        setReloadData(prevState => !prevState)
    }

    const onViewClick = async (e) => {
        navigate(`/positionsViews?opportunity=${e.row.id}&name=${e.row.startup}&startup=${e.row.startupId}&vehicle=${e.row.vehicle}`)
    }

    const onDivestmentClick = async (e) => {
        dispatch(selectOpportunity(e.row))
        setOpenDivest(true)
    }

    const columns = columnsPositions(t, onDeleteClick, onEditClick, onViewClick, onDivestmentClick) 

    return (
        <>
            <TableLayout
                rows={rows}
                columns={columns}
                title='positionsAdmin'
            />
            {
                (userToAction.startup !== '' && openEdit) &&
                <EditOportunity setHidden={setOpenEdit} setReloadData={setReloadData} vehiclesList={vehicles} name='positions'/>
            }
            {
                openDivest && 
                <DivestAll setHidden={setOpenDivest} setReloadData={setReloadData}/>
            }
        </>
    )
}